export const getLineWidth = (totalPageViews: number, maxReach: number) => {
    return (totalPageViews / maxReach) * 100;
}

export const getLineSum = (data: Array<{ total: number }>) => {
    return data.reduce((a, b) => a + (b.total || 0), 0);
}